;
(function ($) {

  let hide = {
    'display': 'none'
  }

  let show = {
    'display': 'flex'
  }

  let mobile = {
    'display' : 'block'
  }

  $(document).ready(function() {

    $('.locations-map-brewery.oskar-blues-brewery').on('load', function() {
      $(this).click();
    });

    $('.locations-map-slider').on('init', function(event, slick, currentSlide, nextSlide) {
      brand_interaction($(this));
    });

    $('.locations-map-slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
      brand_interaction($(this));
    });

    $('a[data-slide]').click(function(e) {
      e.preventDefault();
      var slideno = $(this).data('slide');
      $('.locations-map-slider').slick('slickGoTo', slideno - 1);
    });

    var brewBrew = 'oskar-blues-brewery';
    $(document).on('click', '.locations-map-brewery', function() {
      brand_interaction($(this));

      $('.locations-map-brewery').each((i, e) => {
        $(e).on('click', () => {
          brewBrew = $(e).data('brewery-slug')
          slickIndex = $(e).data('slick-index')
          if ($('body').width() < 768) {
            $('.locations-map-slider').slick('slickGoTo', slickIndex);
          }
        })
      })
    });

    $(document).on('click', '.locations-map-map .active.on', function() {
      $('.locations-map-map .active').removeClass('selected');
      $(this).addClass('selected');
      var state = $(this).attr('id');
      if ($('body').width() <= 768) {
        $('.location-items .location-item.'+brewBrew).css(mobile);
      } else {
        $('.location-items .location-item.'+brewBrew).css(show);
      }
      // $('.location-items .location-item.' + brewBrew).css('display', 'flex').hide().fadeIn('fast')
      $('.location-items .location-item.' + brewBrew + ':not(.' + state + ')').css(hide);
    });


    $('.locations-map-slider').slick({
      centerMode: false,
      slidesToShow: 7,
      swipeToSlide: true,
      infinite: true,
      responsive: [{
          breakpoint: 767,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 3,
            // autoplay: true,
            // autoplaySpeed: 5000,
          }
        }
      ]
    });
    $('.locations-map-slider').show();

    map_menu_animations();
  });

  // Select Oskar Blues on load
  $(window).load(function() {
    $('.locations-map-brewery.oskar-blues-brewery').click();
    $('.locations-map-brewery.oskar-blues-brewery').mouseover();
  });


  function brand_interaction(elem) {

    $('.locations-map-brewery').removeClass('selected');
    elem.addClass('selected');

    if ($('body').width() >= 768) {
      var brewery_slug = elem.data('brewery-slug');
      var brewery_name = elem.data('brewery-name');
    } else {
      var brewery_slug = $('.locations-map-brewery.slick-current').data('brewery-slug');
      var brewery_name = $('.locations-map-brewery.slick-current').data('brewery-name');
    }
    // Display Locations
    $('.locations-list-title h3').html(brewery_name);
    // $('.location-items .location-item').fadeOut('fast');
    $('.location-items .location-item').css(hide)
    // $('.location-items .location-item.'+brewery_slug).fadeIn('fast');
    if ($('body').width() <= 768) {
      $('.location-items .location-item.'+ brewery_slug).css(mobile);
    } else {
      $('.location-items .location-item.' + brewery_slug).css(show)
    }

    // Display Map Icons
    $('.locations-map-map .active').removeClass('on');
    $('.locations-map-map .active').removeClass('selected');
    $('.location-items .location-item.' + brewery_slug).each(function() {
      var state = $(this).data('state');
      $('.locations-map-map .active#' + state).addClass('on');
    });
  }

  function map_menu_animations() {
    if ($('body').width() >= 768) {
      // $('.locations-map-slider').slick('unslick');
      var menu_items = 7;
      // var menu_items_loop_offset = menu_items - 1;
      var width_offset = 100 / menu_items;

      $('.locations-map-brewery')
        .mouseover(function() {
          var index = $('.locations-map-brewery').index(this);
          var move_item = width_offset * index;

          $('.locations-list-items-styles').html('<style>.locations-map-slider:before, .locations-map-slider:after{left:' + move_item + '%}</style>');
        })
        .mouseout(function() {
          var index = $('.locations-map-brewery').index($('.locations-map-brewery.selected'));
          var move_item = width_offset * index;

          $('.locations-list-items-styles').html('<style>.locations-map-slider:before, .locations-map-slider:after{left:' + move_item + '%}</style>');
        });

    }
  }

  // brewery list scroll on drag
  const slider = document.querySelector('.location-items');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });

  $(document).ready(function() {
    let scrollAmount = $('.location-item').width() + 15;

    $(".arrow-left").click(function() {
      $(".location-items").animate({
        scrollLeft: "-=" + scrollAmount

      });
    });
    $(".arrow-right").click(function() {
      $(".location-items").animate({
        scrollLeft: "+=" + scrollAmount
      });
    });



    $("g.state").click(function() {
      if (($('.locations-list-items').offset().top >= $(window).scrollTop()) && ($('.locations-list-items').offset().top < $(window).scrollTop() + $(window).height())) {

      } else {
        $('html, body').animate({
          scrollTop: ($(".locations-list-items").offset().top + $(".locations-list-items").height() - $(window).height())
        }, 750);
      }
    });



  });
})(jQuery);
